module.exports = __webpack_public_path__ + "static/media/dl-national-heritage-corridor.65e799ca.md";